import React from 'react';

import { Icon as IconObject } from '../../core/constants/Icon';
import { Color } from '../../core/enums/Color';

import './Icon.scss';

export type IconSize = 'extra-small' | 'small' | 'medium' | 'full-size';

interface Props {
  className?: string;
  onClick?: () => void;
  icon: keyof typeof IconObject;
  size?: IconSize;
  svg?: boolean;
  isDisabled?: boolean;
  isButton?: boolean;
  withCard?: boolean;
  inline?: boolean;
  color?: Color;
  width?: number;
  height?: number;
}

const iconSize: Record<string, number> = {
  'extra-small': 12,
  small: 22,
  medium: 36
};

const Icon: React.FC<Props> = ({
  icon,
  className = '',
  size = 'medium',
  svg = false,
  onClick,
  isButton = false,
  isDisabled = false,
  withCard = false,
  inline = false,
  color,
  width,
  height
}) => {
  const SVG = IconObject[icon].svg;
  const Element = isButton ? 'button' : 'i';

  let iconClass = `icon icon--${size} icon--${String(icon)}`;
  if (onClick) iconClass += ' icon--clickable';
  if (isDisabled) iconClass += ' icon--disabled';
  if (inline) iconClass += ' icon--inline';
  if (color) iconClass += ` icon--${color}`;
  if (isButton) iconClass += ' icon--button';
  if (withCard) iconClass += ' icon--card';
  if (className) iconClass += ` ${className}`;

  const sizeValue = iconSize[size];
  const svgWidth = width ?? sizeValue;
  const svgHeight = height ?? sizeValue;

  return (
    <Element onClick={!isDisabled ? onClick : undefined} type={isButton ? 'button' : undefined} className={iconClass} disabled={isDisabled}>
      {svg ? <SVG width={svgWidth} height={svgHeight} /> : <img src={IconObject[icon].icon} alt={String(icon)} />}
    </Element>
  );
};

export default Icon;
